import ContainerFlex from "components/ContainerFlex";
import LimitBar from "components/LimitBar/LimitBar";
import { TIPO_CARTAO_CONVENIO, TipoCartao } from "models/tipoCartao";
import "./LimiteDisponivel.css";
import * as St from "./styles";

type UsabilityActive = {
  ADIANTAMENTO_SALARIAL: boolean;
  CESTA_BENEFICIO: boolean
}

type LimiteDisponivelProps = {
  limiteDisponivel: number;
  limiteTotal: number;
  melhorDiaCompra: number;
  statusCliente?: string;
  limiteParcelado12xDisponivel?: number;
  tipoCartao?: TipoCartao;
  limiteCestaDisponivel?: number;
  limiteCestaTotal?: number;
  usabilidadeAtivaModalidades?: UsabilityActive;
};

const LimiteDisponivel = ({
  limiteDisponivel,
  limiteTotal,
  melhorDiaCompra,
  statusCliente,
  limiteParcelado12xDisponivel = 0,
  tipoCartao,
  limiteCestaDisponivel,
  limiteCestaTotal = 0,
  usabilidadeAtivaModalidades,
}: LimiteDisponivelProps) => {
  return (
    <ContainerFlex>
      <ContainerFlex
        row
        style={{
          gap: "3rem",
          marginTop: tipoCartao === TIPO_CARTAO_CONVENIO ? 40 : 0,
        }}
      >
        <ContainerFlex flex={1} style={{ minWidth: 400 }} >
          <St.SpanTitleLimit>
            {tipoCartao === TIPO_CARTAO_CONVENIO ? `Convênio Multi Disponível` : `Limite Disponível`}
            {tipoCartao === TIPO_CARTAO_CONVENIO &&
              usabilidadeAtivaModalidades?.ADIANTAMENTO_SALARIAL === false && (
              <St.InactiveBadge>INATIVO</St.InactiveBadge>
            )}
          </St.SpanTitleLimit>
          <ContainerFlex row>
            <St.SmallTextLimit
              className={limiteDisponivel >= 0 ? "green-text" : "red-text"}
            >
              R$
            </St.SmallTextLimit>

            <St.BiggerTextLimit
              className={limiteDisponivel >= 0 ? "green-text" : "red-text"}
            >
              {limiteDisponivel.toFixed(2).replace(".", ",")}
            </St.BiggerTextLimit>
          </ContainerFlex>

          <ContainerFlex marginTop={16} style={{ maxWidth: 320 }}>
            <LimitBar
              limiteDisponivel={limiteDisponivel}
              limiteTotal={limiteTotal}
            />
          </ContainerFlex>

          <St.SpanTitleLimit style={{ marginTop: 0 }}>
            Limite total:{" "}
            <St.SpanTextLimitBold>
              {limiteTotal.toFixed(2).replace(".", ",")}
            </St.SpanTextLimitBold>
          </St.SpanTitleLimit>
        </ContainerFlex>

        {limiteCestaDisponivel !== undefined && (
            <ContainerFlex flex={1} style={{ minWidth: 400 }}>
              <St.SpanTitleLimit>
                 Saldo Vale-compras Disponível
                {usabilidadeAtivaModalidades?.CESTA_BENEFICIO === false && (
                  <St.InactiveBadge>INATIVO</St.InactiveBadge>
                )}
              </St.SpanTitleLimit>

            <ContainerFlex row>
              <St.SmallTextLimit
                className={
                  limiteCestaDisponivel >= 0 ? "green-text" : "red-text"
                }
              >
                R$
              </St.SmallTextLimit>

              <St.BiggerTextLimit
                className={
                  limiteCestaDisponivel >= 0 ? "green-text" : "red-text"
                }
              >
                {limiteCestaDisponivel.toFixed(2).replace(".", ",")}
              </St.BiggerTextLimit>
            </ContainerFlex>

            <ContainerFlex marginTop={16} style={{ maxWidth: 320 }}>
              <LimitBar
                limiteDisponivel={limiteCestaDisponivel}
                limiteTotal={limiteCestaTotal}
              />
            </ContainerFlex>

            <St.SpanTitleLimit style={{ marginTop: 0 }}>
              Limite total:{" "}
              <St.SpanTextLimitBold>
                {limiteCestaTotal.toFixed(2).replace(".", ",")}
              </St.SpanTextLimitBold>
            </St.SpanTitleLimit>
          </ContainerFlex>
        )}
      </ContainerFlex>
      {statusCliente === "INADIMPLENTE" && (
        <ContainerFlex>
          <St.SmallText className="red-text">
            Possui fatura em atraso
          </St.SmallText>
        </ContainerFlex>
      )}
      <ContainerFlex>
        {tipoCartao !== TIPO_CARTAO_CONVENIO && (
          <St.SpanTitleLimit>
            Melhor dia para compra:
            <St.SpanTextLimitBold>{melhorDiaCompra}</St.SpanTextLimitBold>
          </St.SpanTitleLimit>
        )}
        {limiteParcelado12xDisponivel !== undefined &&
          tipoCartao !== TIPO_CARTAO_CONVENIO && (
            <St.SpanTitleLimit>
              Limite 12x disponível:
              <St.SpanTextLimitBold>{limiteParcelado12xDisponivel.toFixed(2).replace(".", ",")}</St.SpanTextLimitBold>
            </St.SpanTitleLimit>
          )}
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default LimiteDisponivel;
